/** @jsx jsx */
import {graphql, useStaticQuery} from "gatsby"
import Img from "gatsby-image"
import {jsx} from "theme-ui"
import Layout from "../layout"
import Paragraph from "../paragraph"
import SectionHeading from "../SectionHeading"
import Sign from "../../icons/ourstory-sign.svg"

export default function OurStory(props) {
    const data = useStaticQuery(graphql`
        {
            file(sourceInstanceName: {eq: "ourstory"}) {
                id
                childImageSharp {
                    resize {
                        height
                    }
                    fluid {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)
    return(
       <Layout>
           <div id={props.id} sx={{
               display: 'flex',
               alignItems: 'center',
               py: [10,10,17]
           }}>
                <div sx={{
                    width: '40%',
                    mr: 7,
                    position: 'relative',
                    display: ['none','block','block']
                }}>
                    <Sign sx={{
                        position: 'absolute',
                        left: '-12rem',
                        top: '-4rem',
                        zIndex: 1,
                        fill: 'neutral300'
                    }} />
                    <Img fluid={data.file.childImageSharp.fluid} sx={{borderRadius: '6px'}} alt="About us" /> 
                </div>
                <div sx={{
                    width: ['100%','100%','60%']
                }}>
                    <SectionHeading caption="Where we started" smallMargin>Our Story</SectionHeading>
                    <Paragraph>Are you in the mood for delicious food using fresh ingredients at an affordable price? If so, then we are the destination for you. We opened Simon's Chinese Cuisine to offer scrumptious cuisine to our diners that can be enjoyed in our restaurant or in the comfort of your home. Our menu features many mouth-watering dishes and scratch made specials. We love doing our part to feed the local community. Try us out today, you will not be disappointed!</Paragraph>
                </div>
           </div>
       </Layout>
    )
}